import { useQuery } from "react-query";
import {
  getChowdeckProducts,
  getLumiProducts,
  getMappedUnmappedChowdeckProducts,
  getMarketPlaceConnections,
  getMarketPlaceStores,
  getStoreMappingDetails,
  getStoresMappingList,
} from "../../../services/marketplace";

export const useGetMarketPlaceConnections = () => {
  return useQuery(["marketPlaceConnections"], () =>
    getMarketPlaceConnections().then((res) => res?.data?.data),
  );
};

export const useGetStoresMappingList = ({
  isEnabled = true,
  queries = "",
  queryParams = {},
}) => {
  return useQuery(
    ["storesMappingList", queries, queryParams],
    () => getStoresMappingList(queries, queryParams).then((res) => res?.data),
    {
      enabled: isEnabled,
    },
  );
};

export const useGetMarketPlaceStores = ({
  isEnabled = true,
  queries = "",
  queryParams = {},
  providerKey = "",
}) => {
  return useQuery(
    ["getMarketPlaceStores", queries, queryParams, providerKey],
    () =>
      getMarketPlaceStores(queries, queryParams, providerKey).then(
        (res) => res?.data?.data,
      ),
    {
      staleTime: Infinity,
      enabled: isEnabled,
    },
  );
};

export const useGetChowdeckProducts = ({
  isEnabled = true,
  queries = "",
  queryParams = {},
}) => {
  return useQuery(
    ["getChowdeckProducts", queries, queryParams],
    () =>
      getChowdeckProducts(queries, queryParams).then((res) => res?.data?.data),
    {
      enabled: isEnabled,
      staleTime: Infinity,
    },
  );
};

export const useGetLumiProducts = ({
  isEnabled = true,
  queries = "",
  queryParams = {},
}) => {
  return useQuery(
    ["getLumiProducts", queries, queryParams],
    () => getLumiProducts(queries, queryParams).then((res) => res?.data?.data),
    {
      enabled: isEnabled,
      staleTime: Infinity,
    },
  );
};

export const useGetStoreMappingDetails = ({
  isEnabled = true,
  id = "",
  queryParams = {},
}) => {
  return useQuery(
    ["getStoreMappingDetails", queryParams],
    () =>
      getStoreMappingDetails({ id, queryParams }).then(
        (res) => res?.data?.data,
      ),
    {
      enabled: isEnabled,
      staleTime: Infinity,
    },
  );
};

export const useGetMappedUnmappedChowdeckProducts = ({
  isEnabled = true,
  queries = "",
  queryParams = {},
}) => {
  return useQuery(
    ["getMappedUnmappedChowdeckProducts", queries, queryParams],
    () =>
      getMappedUnmappedChowdeckProducts(queries, queryParams).then(
        (res) => res?.data?.data,
      ),
    {
      enabled: isEnabled,
      staleTime: Infinity,
    },
  );
};
